module.exports = __webpack_public_path__ + "static/media/timer.7bc5352d.png";